<template>
  <div class="loading-container">
    <div class="spinner"></div>
    <div class="loading-text">加载中...</div>
  </div>
</template>

<script>
import { setToken, setRefreshToken } from "@saas/server-api/src/plugins/auth";

export default {
  name: "mini-redirect",
  data() {
    return {
      path: "",
      accessToken: "",
      refreshToken: "",
    };
  },
  created() {
    const params = new URLSearchParams(window.location.search);
    this.accessToken = params.get("accessToken");
    this.refreshToken = params.get("refreshToken");
    this.path = params.get("path");
    console.log("========1 this.path", this.path);
    if (this.accessToken) {
      console.log("========2 this.accessToken", this.accessToken, this.refreshToken)

      setToken(this.accessToken);
      setRefreshToken(this.refreshToken);
      console.log("========3 setToken");
      if (this.path) {
        console.log("========4 replace");
        console.log("========4 ",this.$router);
        this.$router.push({
          path: this.path,
        });
      }
    }
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f5f5f5;
}

.spinner {
  border: 2px solid rgba(0, 0, 0, 0.1);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border-left-color: #0d1400;
  animation: spin 1s ease infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-text {
  margin-top: 10px;
  font-size: 14px;
  color: #333;
}
</style>
